import Card from "../../Components/Card"
import {Main }from "./style"
import Projects from "../../Components/Projects"
import Aside from "../../Components/Aside"
import Menu from "../../Components/Menu"


const Home = () =>{
    return(
        <>
        <Aside/>
        <Main>
            <Card path={'/about'} button={'Sobre mim'}/>
            <Menu/>
            <Projects/>
        </Main>
        </>
    )
}

export default Home